// extracted by mini-css-extract-plugin
module.exports = {"disableSelect":"src-js-sign-components-common-hooks-module__disableSelect--2zWhS"};